var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompanyMen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "company_-_men",
    "data-name": "company - men",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114.512,
    height: 193.401,
    viewBox: "0 0 114.512 193.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9259",
    "data-name": "Rectangle 9259",
    width: 114.512,
    height: 193.401,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58254",
    "data-name": "Group 58254",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86624",
    "data-name": "Path 86624",
    d: "M65.77,146.43s.548,31.8-13.938,31.136c-8.3-.383-17.847-10.187-17.847-10.187l4.2-5.129,11.7-2.623L57.6,142.086Z",
    transform: "translate(-16.8 -70.24)",
    fill: "#ef6159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86625",
    "data-name": "Path 86625",
    d: "M69.2,125.209s9.07-27.971,16.32-28.677c9.069-.883,8.493,11.942,8.559,14.146.229,7.319-3.145,21.746-3.145,21.746Z",
    transform: "translate(-34.208 -47.699)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_764",
    "data-name": "Line 764",
    x1: 16.369,
    y1: 5.617,
    transform: "translate(38.802 75.419)",
    fill: "none",
    stroke: "#78af31",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86626",
    "data-name": "Path 86626",
    d: "M136.809,29.216s2.432-5.33,1.959-8.978-6.216-2.77-6.216-2.77-.516-4.122-7.724-3.852-13.054-.939-13.1,5.949,13.1,5.334,13.1,5.334l7.116,6.621s1.243.714,1.736.458,3.128-2.763,3.128-2.763",
    transform: "translate(-55.231 -6.725)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86627",
    "data-name": "Path 86627",
    d: "M84.221,281.483l3.417,49.823h63.511V278.962Z",
    transform: "translate(-41.635 -137.905)",
    fill: "#3f3936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86628",
    "data-name": "Path 86628",
    d: "M151.517,292.656v8.077l-66.551-8.077Z",
    transform: "translate(-42.003 -144.674)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86629",
    "data-name": "Path 86629",
    d: "M27.126,174.855s-9.031-.767-9.6.728,4.023,2.482,4.023,2.482S12,181.122,11.9,182.922s6.842-.342,6.842-.342-6.874,2.661-6.641,4.147,7.4-1.265,7.4-1.265-5.8,3.863-4.845,4.753,6.8-2.673,6.8-2.673-4.783,3.647-3.878,4.415c1.133.961,9.689-5.03,12.884-11.426l.073-2.424-1.428-1.6Z",
    transform: "translate(-5.881 -86.342)",
    fill: "#ef6159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86630",
    "data-name": "Path 86630",
    d: "M23.665,169.1c12.124,0,16.98,8.019,16.98,8.019L23.665,194.1,6.685,177.12s4.856-8.019,16.98-8.019",
    transform: "translate(-3.305 -83.595)",
    fill: "#001a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86631",
    "data-name": "Path 86631",
    d: "M23.665,169.1c12.124,0,16.98,8.019,16.98,8.019l-.029.029H6.714l-.029-.029s4.856-8.019,16.98-8.019",
    transform: "translate(-3.305 -83.595)",
    fill: "#456a70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86632",
    "data-name": "Path 86632",
    d: "M74.338,194.4h76.923l-6.491-46.96L142.328,129.8l-1.73-12.537-.108-.79-1.522-10.986L137.539,95.15c-.546-.072-1.106-.144-1.68-.208-5.184-.632-11.288-1.049-17.908-1.192-1.687-.036-3.411-.057-5.156-.057-4.028,0-7.92.1-11.589.294-4.84.244-9.284.646-13.147,1.163l-1.335,9.657-.093.675-1.766,12.774-.338,2.434-.4,2.915-.653,4.739-.79,5.679-1.487,10.8-.941,6.8-.2,1.472-.144,1.041-.316,2.254-.259,1.867-.5,3.59L77.2,173.667l-.46,3.339Z",
    transform: "translate(-36.749 -46.317)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86633",
    "data-name": "Path 86633",
    d: "M131.007,106.667a10.014,10.014,0,0,1-7.407-2.735,11.194,11.194,0,0,1-2.928-7.321.758.758,0,0,1,.758-.753h0a.76.76,0,0,1,.754.764,9.8,9.8,0,0,0,2.5,6.251,8.57,8.57,0,0,0,6.322,2.277c8.77,0,9.123-8.958,9.134-9.339a.758.758,0,0,1,1.516.039c0,.108-.392,10.816-10.651,10.816",
    transform: "translate(-59.654 -46.999)",
    fill: "#9acc52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86634",
    "data-name": "Path 86634",
    d: "M84.221,180.56c10.871,3.087,29.288,6.505,45.365,2.291a36.783,36.783,0,0,0,20.069-13.111l-4.172-30.179-.812-.754-23.939,33.037-17.24,6.462-18.353-4.38Z",
    transform: "translate(-41.635 -68.619)",
    fill: "#053f66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86635",
    "data-name": "Path 86635",
    d: "M57.628,178.3s31,6.156,46.555,1.489a39.737,39.737,0,0,0,17.262-10.526,44.587,44.587,0,0,0,9.507-14.72c.158-.409.23-.632.23-.632l-19.53-8.228a.421.421,0,0,1-.036.05c-.144.28-.488,1.58-1.163,3.425a38.364,38.364,0,0,1-3.353,6.958A25.924,25.924,0,0,1,99.753,164c-6.821,4.624-28.082,6.174-35.255,6.383-2.52.058-1.494.561-1.494.561Z",
    transform: "translate(-28.488 -72.017)",
    fill: "#ffa788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86636",
    "data-name": "Path 86636",
    d: "M155.463,159.51c2.779,2.578,9.471,8.767,14.346,13.147a44.584,44.584,0,0,0,9.507-14.72c-4.488-1.192-13.815-3.655-20.5-5.385a38.419,38.419,0,0,1-3.353,6.958",
    transform: "translate(-76.853 -75.414)",
    fill: "#ef6159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86637",
    "data-name": "Path 86637",
    d: "M53.809,190.4s-5-7.558-6.53-7.08.55,4.695.55,4.695-8.319-5.586-9.8-4.55,4.514,5.154,4.514,5.154-6.352-3.74-7.373-2.634S40.755,191,40.755,191s-6.629-2.152-6.734-.851,6.314,3.672,6.314,3.672-5.829-1.488-5.869-.3C34.416,195,44.423,198,51.422,196.531l1.946-1.446.367-2.112Z",
    transform: "translate(-16.818 -90.614)",
    fill: "#ffa788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86638",
    "data-name": "Path 86638",
    d: "M46.038,189.475a.25.25,0,0,1-.141-.043c-4.066-2.74-4.772-4.5-4.8-4.571a.253.253,0,0,1,.472-.182c.013.032.728,1.717,4.61,4.332a.253.253,0,0,1-.141.463",
    transform: "translate(-20.308 -91.216)",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86639",
    "data-name": "Path 86639",
    d: "M41.61,194.207a.257.257,0,0,1-.124-.032,20.058,20.058,0,0,1-5.682-4.49.253.253,0,0,1,.4-.311,19.961,19.961,0,0,0,5.532,4.361.253.253,0,0,1-.124.473",
    transform: "translate(-17.673 -93.569)",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86640",
    "data-name": "Path 86640",
    d: "M40.088,200.747a.253.253,0,0,1-.079-.013c-5.148-1.69-6.4-3.467-6.446-3.541a.253.253,0,0,1,.418-.285c.012.017,1.239,1.721,6.186,3.345a.253.253,0,0,1-.079.493",
    transform: "translate(-16.57 -97.287)",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86641",
    "data-name": "Path 86641",
    d: "M60.576,190.212a.252.252,0,0,1-.21-.112,12.918,12.918,0,0,1-1.714-4.52.253.253,0,0,1,.5-.081,12.65,12.65,0,0,0,1.635,4.319.252.252,0,0,1-.069.35.25.25,0,0,1-.141.043",
    transform: "translate(-28.993 -91.596)",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86642",
    "data-name": "Path 86642",
    d: "M134.159,85.7h0a7.087,7.087,0,0,1-7.081-7.094l.018-19,14.175.014-.018,19a7.088,7.088,0,0,1-7.094,7.081",
    transform: "translate(-62.821 -29.467)",
    fill: "#ffa788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86643",
    "data-name": "Path 86643",
    d: "M127.1,63.268l-.013,13.674c10.742-2.03,12.783-12.522,12.783-12.522s-8.2-1.366-10.9-1.368a10.92,10.92,0,0,0-1.87.216",
    transform: "translate(-62.824 -31.17)",
    fill: "#ef6159"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86644",
    "data-name": "Path 86644",
    d: "M111.211,25.394s-1.791,17.951,1.243,24.38c3.1,6.572,15.177,7.973,20.67-7.066,0,0,5.015.527,5.945-3.009s-2.793-6.6-6.31-3.656c0,0-1.991-3-2.683-9.636,0,0-13.75,3.8-18.865-1.012",
    transform: "translate(-54.718 -12.554)",
    fill: "#ffa788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86645",
    "data-name": "Path 86645",
    d: "M157.943,51.684a2.683,2.683,0,0,1-1.467-.429A.758.758,0,1,1,157.33,50a1.263,1.263,0,0,0,1.44-.14,1.338,1.338,0,0,0,.4-1.362c-.033-.13-.164-.559-.5-.613a1.488,1.488,0,0,0-1.3.3.768.768,0,0,1-1.066.023.75.75,0,0,1-.049-1.052,3,3,0,0,1,2.652-.772,2.21,2.21,0,0,1,1.737,1.745,2.807,2.807,0,0,1-2.7,3.55",
    transform: "translate(-77.149 -22.91)",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86646",
    "data-name": "Path 86646",
    d: "M129.74,66.195s-.674,3.536-3.6,3.588c-3.007.055-3.294-3.464-3.294-3.464Z",
    transform: "translate(-60.727 -32.723)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86647",
    "data-name": "Path 86647",
    d: "M123.913,55.6a.708.708,0,0,1-.073,0c-1.8-.17-2.723-.377-3.062-1.091-.315-.663.094-1.276.527-1.924a6.249,6.249,0,0,0,1.282-3.41.77.77,0,0,1,.787-.73.759.759,0,0,1,.73.786,7.676,7.676,0,0,1-1.537,4.2c-.085.127-.188.281-.266.41a10.518,10.518,0,0,0,1.683.252.758.758,0,0,1-.071,1.513",
    transform: "translate(-59.651 -23.949)",
    fill: "#f47160"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86648",
    "data-name": "Path 86648",
    d: "M117.436,44.51a.757.757,0,0,1-.491-.181,2.234,2.234,0,0,0-2.711-.216.758.758,0,0,1-.854-1.254,3.773,3.773,0,0,1,4.549.314.759.759,0,0,1-.493,1.336",
    transform: "translate(-55.887 -20.882)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86649",
    "data-name": "Path 86649",
    d: "M116.393,47.54a1.344,1.344,0,0,0-1.169.924l1.2.917-1.374-.156c0,.049-.011.1-.011.147,0,1.012.6,1.833,1.35,1.834s1.353-.82,1.354-1.831-.6-1.833-1.35-1.834",
    transform: "translate(-56.869 -23.501)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86650",
    "data-name": "Path 86650",
    d: "M130.915,44.523a.758.758,0,0,1-.492-1.337,3.768,3.768,0,0,1,4.55-.305.759.759,0,0,1-.858,1.251,2.234,2.234,0,0,0-2.71.211.757.757,0,0,1-.49.18",
    transform: "translate(-64.342 -20.89)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86651",
    "data-name": "Path 86651",
    d: "M133.428,47.359a1.423,1.423,0,0,0-1.238.988l1.236.945-1.414-.16c0,.053-.012.1-.012.159,0,1.067.637,1.933,1.424,1.934s1.426-.864,1.427-1.931-.637-1.934-1.424-1.934",
    transform: "translate(-65.255 -23.412)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86652",
    "data-name": "Path 86652",
    d: "M148.157,129.9s15.836-34.1,25.149-33.881c11.649.28,8.936,16.473,8.678,19.28-.84,9.327-7.353,27.12-7.353,27.12Z",
    transform: "translate(-73.241 -47.467)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86653",
    "data-name": "Path 86653",
    d: "M177.288,168.625a1.01,1.01,0,0,1-.441-.1l-19.911-9.66a1.011,1.011,0,1,1,.883-1.82l19.911,9.66a1.011,1.011,0,0,1-.442,1.921",
    transform: "translate(-77.299 -77.584)",
    fill: "#78af31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86654",
    "data-name": "Path 86654",
    d: "M137.093,313.892l4.756,34.682h-4.756Z",
    transform: "translate(-67.772 -155.172)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86655",
    "data-name": "Path 86655",
    d: "M148.526,302.811H90.719a.758.758,0,1,1,0-1.517h57.806a.758.758,0,1,1,0,1.517",
    transform: "translate(-44.472 -148.944)",
    fill: "#7a716e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86656",
    "data-name": "Path 86656",
    d: "M140.05,315.805h-4.98V302.053a.758.758,0,1,1,1.517,0v12.235h3.463a.758.758,0,0,1,0,1.517",
    transform: "translate(-66.772 -148.945)",
    fill: "#7a716e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9257",
    "data-name": "Rectangle 9257",
    width: 34.087,
    height: 2.504,
    transform: "translate(51.528 16.57)",
    fill: "#ff831a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86657",
    "data-name": "Path 86657",
    d: "M110.023,16.57V14.138a14.138,14.138,0,1,1,28.276,0V16.57Z",
    transform: "translate(-54.39 0)",
    fill: "#ffb51a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86658",
    "data-name": "Path 86658",
    d: "M133.823.156a14.142,14.142,0,0,1,16.242,13.982V16.57h-4.208V14.138A14.14,14.14,0,0,0,133.823.156",
    transform: "translate(-66.155 0)",
    fill: "#ff831a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9258",
    "data-name": "Rectangle 9258",
    width: 28.277,
    height: 1.252,
    transform: "translate(55.633 15.318)",
    fill: "#ff831a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86659",
    "data-name": "Path 86659",
    d: "M131.84,0l1.121.089s-7.094.89-7.094,16.482h-1.242S124.244,3.091,131.84,0",
    transform: "translate(-61.607)",
    fill: "#ff831a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86660",
    "data-name": "Path 86660",
    d: "M117.459,4.52a14.166,14.166,0,0,1,2.077-1.332c-2,1.858-4.364,5.955-4.364,14.959h-1.242s-.238-8.588,3.529-13.626",
    transform: "translate(-56.319 -1.576)",
    fill: "#ff831a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86661",
    "data-name": "Path 86661",
    d: "M21.122,144.2s.563-11.105-9.415-13.922S.447,123.153.447,123.153s-2.34,9.456,3.7,16.638c6.231,7.415,16.98,4.406,16.98,4.406",
    transform: "translate(0 -60.881)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86662",
    "data-name": "Path 86662",
    d: "M4.142,139.791c6.232,7.415,16.98,4.406,16.98,4.406s-.621-4.8-10.558-9.174S.447,123.153.447,123.153s-2.34,9.456,3.7,16.638",
    transform: "translate(0 -60.881)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86663",
    "data-name": "Path 86663",
    d: "M.883,123.153c.666,5.161,4.8,9.14,9.33,11.275a38.7,38.7,0,0,1,6.722,3.761c1.976,1.563,4.046,3.461,4.624,6.008-1.292-3.949-5.422-6.364-8.9-8.2a43.251,43.251,0,0,1-4.309-2.151C4.513,131.6,1.2,127.731.883,123.153",
    transform: "translate(-0.437 -60.881)",
    fill: "#afdb71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86664",
    "data-name": "Path 86664",
    d: "M41.766,146.766s-.493-9.719,8.24-12.183,9.854-6.233,9.854-6.233,2.048,8.275-3.234,14.56c-5.453,6.489-14.86,3.856-14.86,3.856",
    transform: "translate(-20.644 -63.45)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86665",
    "data-name": "Path 86665",
    d: "M56.631,142.91c-5.453,6.49-14.86,3.856-14.86,3.856s.544-4.2,9.239-8.028,8.854-10.388,8.854-10.388,2.048,8.275-3.234,14.56",
    transform: "translate(-20.649 -63.45)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86666",
    "data-name": "Path 86666",
    d: "M59.864,128.35c-.277,4.335-3.588,7.825-7.249,9.811-1.224.633-2.573,1.186-3.783,1.835-2.832,1.571-5.986,3.545-7.061,6.77a6.874,6.874,0,0,1,1.564-2.961c2.191-2.621,5.319-4.184,8.353-5.609,3.962-1.866,7.575-5.339,8.175-9.846",
    transform: "translate(-20.649 -63.45)",
    fill: "#afdb71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyMen);
export default __webpack_public_path__ + "static/media/company_men.af11f6465260924a97f715d75697fab3.svg";
export { ForwardRef as ReactComponent };